import { HttpMethod } from "../../common/constants/http-requests";
import { httpRequest } from "../../common/utils/http-request";
import { DROPDOWN } from "../api";

/** In-memory cache for get-list-items (master data). TTL: 12 hours. */
const LIST_ITEMS_CACHE_TTL_MS = 12 * 60 * 60 * 1000;
const listItemsCache = new Map(); // code -> { data, expiresAt }

function getCachedListItems(code) {
  const key = code && String(code).trim();
  if (!key) return null;
  const entry = listItemsCache.get(key);
  if (!entry || Date.now() > entry.expiresAt) return null;
  return entry.data;
}

function setCachedListItems(code, data) {
  const key = code && String(code).trim();
  if (!key) return;
  listItemsCache.set(key, {
    data,
    expiresAt: Date.now() + LIST_ITEMS_CACHE_TTL_MS,
  });
}

export const getProjectManagersList = () =>
  httpRequest({
    url: `${DROPDOWN}/get-project-managers`,
    method: HttpMethod.GET,
  });

export const getAllClients = () =>
  httpRequest({
    url: `${DROPDOWN}/get-all-clients`,
    method: HttpMethod.GET,
  });

/**
 * Get list items (master data) by code. Results are cached in memory for 12 hours.
 * Subsequent calls with the same code return cached data without calling the API.
 */
export const getListItems = (code) => {
  const key = code != null ? String(code).trim() : "";
  const cached = key ? getCachedListItems(key) : null;
  if (cached !== null) return Promise.resolve(cached);
  return httpRequest({
    url: `${DROPDOWN}/${encodeURIComponent(key)}/get-list-items`,
    method: HttpMethod.GET,
  }).then((data) => {
    if (key) setCachedListItems(key, data ?? []);
    return data ?? [];
  });
};

export const getAllUsers = () =>
  httpRequest({
    url: `${DROPDOWN}/get-all-users`,
    method: HttpMethod.GET,
  });

export const getAllProjectsDetails = () =>
  httpRequest({
    url: `${DROPDOWN}/get-all-projects`,
    method: HttpMethod.GET,
  });

export const projectTasksDetails = () =>
  httpRequest({
    url: `${DROPDOWN}/get-project-tasks`,
    method: HttpMethod.GET,
  });

export const getAssignedProjectsDetails = (payload) => 
httpRequest({
  url: `${DROPDOWN}/get-projects-assigned-to-user?startDate=${payload.startDate}&endDate=${payload.endDate}`,
  method: HttpMethod.GET,
  });

export const getReportees = (projectId) => {
  let query = projectId === null ? "" : `?projectId=${projectId}`
  return httpRequest({
    url: `${DROPDOWN}/get-reportees${query}`,
    method: HttpMethod.GET,
  })};

export const getTimesheetProjects = () => 
  httpRequest({
    url: `${DROPDOWN}/get-associated-projects`,
    method: HttpMethod.GET,
  });

/** Uses same get-list-items endpoint and cache as getListItems('skillBucket'). */
export const getSkillsData = () => getListItems("skillBucket");